import{useEffect as n}from"react";function o(o){var r=o.formData,t=o.onChange;return n((function(){void 0===r&&t(null)}),[r,t]),null}export{o as default};
